// docs react-leaflet https://react-leaflet.js.org/legacy/docs/en/components#zoomcontrol
import React from 'react';
import * as L from 'leaflet';
import { Map as MapContainer, TileLayer, ZoomControl, MapProps } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import { Container, IContainer, GlobalMapStyle } from './style';
import { tileLayersMap } from './tileLayers';

export interface IMap extends IContainer {
  coords: [number, number];
  children?: React.ReactNode;
  zoom: number;
  scrollWheelZoom?: boolean;
  layerType?: number;
  refMapElement?: any;
  doubleClickZoom?: boolean;
  onClick?: any;
  maxZoom?: number;
  minZoom?: number;
  dragging?: boolean;
  coordsOffset?: [number, number];
}

export type IMapContainer = MapContainer<MapProps, L.Map>;

export const Map = ({
  coords,
  coordsOffset = [0, 0],
  zoom,
  scrollWheelZoom,
  children,
  height = 420,
  width,
  maxHeight,
  minHeight,
  maxWidth,
  minWidth,
  resize,
  margin,
  positionResize,
  refMapElement,
  doubleClickZoom = true,
  layerType = 4,
  onClick,
  maxZoom,
  minZoom,
  dragging = true,
}: IMap) => {
  const ref = React.useRef<MapContainer<MapProps, L.Map>>();
  const tyleLayer = tileLayersMap[layerType - 1];

  if (typeof refMapElement === 'object') {
    refMapElement.current = ref.current;
  }

  React.useEffect(() => {
    const coodsSerialized: [number, number] = [coords[0] + coordsOffset[0], coords[1] + coordsOffset[1]];
    setTimeout(() => ref.current?.leafletElement?.flyTo(coodsSerialized));
  }, [coords]);

  return (
    <Container
      margin={margin}
      positionResize={positionResize}
      resize={resize}
      minHeight={minHeight}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      minWidth={minWidth}
      height={height}
      width={width}
    >
      <GlobalMapStyle />

      <MapContainer
        ref={ref as any}
        center={coords}
        zoom={zoom}
        scrollWheelZoom={scrollWheelZoom}
        zoomControl={false}
        doubleClickZoom={doubleClickZoom}
        onClick={onClick}
        maxZoom={maxZoom}
        minZoom={minZoom}
        dragging={dragging}
      >
        <TileLayer url={tyleLayer?.url} subdomains={tyleLayer?.subdomains} />
        <ZoomControl position="bottomright" />

        {children}
      </MapContainer>
    </Container>
  );
};

export default Map;
export { Marker } from './Marker';
